<div class="content" #viewContainerRef>
  <div class="title">
    {{ 'INFO_PAGE.' + infoType + '.TITLE' | translate }}
  </div>
  <div class="sub-title">
    {{ 'INFO_PAGE.' + infoType + '.MESSAGE' | translate }}
  </div>
  <img src="../../../../assets/images/not-found.svg" />
  <div class="contract-us" [innerHTML]="'INFO_PAGE.CONTACT_US' | translate"></div>
</div>
